import templateUrl from './bulletins-dashboard.component.html'

/**
 * A component that loads and displays the user's unacknowledged bulletins.
 */
export const BulletinsDashboardComponent = {
    bindings: {
        messages: "<",
        acknowledgeBulletin: "&",
        acknowledgeAllBulletins: "&"
    },
    templateUrl,
    controller: class BulletinsDashboardController {
        constructor() {
            this.pageSize = 10;
            this.pageNumber = 1;
        }

        /**
         * Return whether all acknowledgable items in the given list have been
         * acknowledged.
         * @param {{IsAcknowledged: boolean}[]} acknowledgableList A list of
         *   elements with an IsAcknowledged property.
         * @returns {boolean} Whether all items are acknowledged.
         */
        allAcknowledged(acknowledgableList) {
            return acknowledgableList.reduce(function (all, item) {
                return all && item.IsAcknowledged;
            }, true);
        }
    },
    controllerAs: "vm"
}
